import type { FunctionComponent } from 'react'
import React from 'react'
import { useScreenSize } from '@ztechapps/common.hook'
import { Switch } from '../Switch'

/**
 * Toggle which item to show when the screen is resize
 * @constructor
 */
export const ToggleToScreenSize = (props: { desktop: FunctionComponent; mobile: FunctionComponent }) => {
  const screenSize = useScreenSize()

  return <Switch expression={screenSize}>{{ mobile: <props.mobile />, desktop: <props.desktop /> }}</Switch>
}
